export default __webpack_public_path__ + "static/char-v-45-080fb0b8e2cced2565b824b2a0ab1981.webp";